import React from "react";
import EntryList from "../EntryList";
import { explorerStyles } from "./style.js";
import { TYPES } from "../../segments/FileSystem";
import PopUpMenu from "../PopUpMenu";
import {
  FileAddOutlined,
  FolderAddOutlined,
  RollbackOutlined,
  FolderOpenOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

class FileExplorer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDirectory: null,
      currentContent: {},
      inputValue: "",
      popUpOn: false,
      popUpPosition: {},
      popUpEntries: [],
    };

    this.changeInputValue = this.changeInputValue.bind(this);
    this.createDirectory = this.createDirectory.bind(this);
    this.createFile = this.createFile.bind(this);
    this.highlight = this.highlight.bind(this);
    this.unhighlight = this.unhighlight.bind(this);
    this.changeCurrentDirectory = this.changeCurrentDirectory.bind(this);
    this.setNameOnChange = this.setNameOnChange.bind(this);
    this.saveName = this.saveName.bind(this);
    this.setPopUp = this.setPopUp.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
    this.deleteNode = this.deleteNode.bind(this);
    this.reloadCurrentContent = this.reloadCurrentContent.bind(this);
  }

  componentDidMount() {
    this.props.fileSystem.addSaveCallBack(this.reloadCurrentContent);
    if (this.props.currentDirectoryHash)
      this.changeCurrentDirectory(this.props.currentDirectoryHash);

    if (this.props.currentDirectoryHash === "bin") {
      this.props.fileSystem.setOnRemove(() =>
        this.changeCurrentDirectory(this.props.currentDirectoryHash)
      );
    }
  }

  reloadCurrentContent() {
    let currentContent = this.state.currentDirectory.getChildren();
    currentContent = { ...currentContent };
    for (let key in currentContent) {
      currentContent[key] = {
        metadata: currentContent[key],
        nameOnChange: false,
      };
    }
    this.setState((state) => ({
      ...state,
      popUpOn: false,
      currentContent,
    }));
  }

  changeCurrentDirectory(hash) {
    const fileSystem = this.props.fileSystem;
    const currentDirectory = fileSystem.getDirectory(hash);
    let currentContent = currentDirectory.getChildren();
    currentContent = { ...currentContent };
    for (let key in currentContent) {
      currentContent[key] = {
        metadata: currentContent[key],
        nameOnChange: false,
      };
    }

    this.setState((state) => ({
      ...state,
      currentDirectory,
      currentContent,
    }));
  }

  highlight(e) {
    e.target.style.opacity = 0.8;
  }

  unhighlight(e) {
    e.target.style.opacity = 1;
  }

  changeInputValue(e) {
    this.setState((state) => ({
      ...state,
      inputValue: e.target.value,
    }));
  }

  createFile() {
    const fileSystem = this.props.fileSystem;
    const parent = this.state.currentDirectory.getHash();
    let hash = null;
    if (this.state.inputValue !== "") {
      hash = fileSystem.createNewFile(parent, this.state.inputValue, "");
    } else {
      hash = fileSystem.createNewFile(parent, "New File", "");
    }
    if (hash !== null) {
      this.reloadCurrentContent();
    } else {
      window.alert("File Name already in use");
    }
  }

  createDirectory() {
    const fileSystem = this.props.fileSystem;
    const parent = this.state.currentDirectory.getHash();
    let hash = null;
    if (this.state.inputValue !== "") {
      hash = fileSystem.createNewDirectory(parent, this.state.inputValue);
    } else {
      hash = fileSystem.createNewDirectory(parent, "New Folder");
    }
    if (hash !== null) {
      this.reloadCurrentContent();
    } else {
      window.alert("File Name already in use");
    }
  }

  deleteNode(hash) {
    if (this.state.currentDirectory.isBin())
      this.props.fileSystem.deepRemoveNode(hash);
    else
      this.props.fileSystem.removeNode(
        this.state.currentDirectory.getHash(),
        hash
      );
    this.reloadCurrentContent();
  }

  setNameOnChange(key, value) {
    const currentContent = this.state.currentContent;
    currentContent[key].nameOnChange = value;
    this.setState((state) => ({
      ...state,
      currentContent,
    }));
  }

  saveName(hash, name, type) {
    if (name === "") {
      alert("the file name cannot be empty!");
      return;
    } else if (name.length >= 25) {
      alert("the file name exceeded the length limit!");
      return;
    } else if (type === TYPES.FILE) {
      this.props.fileSystem.changeFileName(hash, name);
    } else {
      this.props.fileSystem.changeDirectoryName(hash, name);
    }
    const currentContent = this.state.currentContent;
    currentContent[hash].metadata.name = name;
    currentContent[hash].nameOnChange = false;
    this.setState((state) => ({
      ...state,
      currentContent,
    }));
  }

  closePopUp(e) {
    e.preventDefault();
    if (e.type === "click")
      window.removeEventListener("click", this.closePopUp);
    else window.removeEventListener("contextmenu", this.closePopUp);
    this.setState((state) => ({
      ...state,
      popUpOn: false,
    }));
  }

  setPopUp(x, y, entries) {
    this.setState((state) => ({
      ...state,
      popUpOn: true,
      popUpPosition: { x, y },
      popUpEntries: entries,
    }));
  }

  handleContextMenu(e, metadata) {
    window.addEventListener("click", this.closePopUp);
    e.preventDefault();
    this.setPopUp(e.clientX, e.clientY, [
      {
        content: "Delete",
        func: () => this.deleteNode(metadata.hash),
      },
      {
        content: "Rename",
        func: () => {
          this.setNameOnChange(metadata.hash, true);
        },
      },
    ]);
  }

  render() {
    let entries = [];
    const currentDirectory = this.state.currentDirectory;
    const currentContent = this.state.currentContent;

    if (currentDirectory && currentContent !== {}) {
      for (let key in currentContent) {
        const metadata = currentContent[key].metadata;
        if (metadata.type === TYPES.DIR) {
          entries.push({
            content: (
              <div>
                <FolderOpenOutlined /> {metadata.name}
              </div>
            ),
            value: metadata.name,
            valueOnChange: currentContent[key].nameOnChange,
            func: () => {
              this.changeCurrentDirectory(metadata.hash);
            },
            contextFunc: (e) => {
              this.handleContextMenu(e, metadata);
            },
            enterFunc: (name) => {
              this.saveName(metadata.hash, name, metadata.type);
            },
            cancelFunc: () => {
              this.setNameOnChange(key, false);
            },
          });
        } else {
          entries.push({
            content: (
              <div>
                <FileTextOutlined /> {metadata.name}
              </div>
            ),
            value: metadata.name,
            valueOnChange: currentContent[key].nameOnChange,
            func: () => {
              this.props.openFile(this.props.fileSystem.getFile(metadata.hash));
            },
            contextFunc: (e) => {
              this.handleContextMenu(e, metadata);
            },
            enterFunc: (name) => {
              this.saveName(metadata.hash, name, metadata.type);
            },
            cancelFunc: () => {
              this.setNameOnChange(key, false);
            },
          });
        }
      }
    }
    return (
      <div
        style={{
          height: this.props.height,
          width: this.props.width,
          ...explorerStyles.container,
        }}
      >
        {this.state.popUpOn && (
          <PopUpMenu
            top={this.state.popUpPosition.y}
            left={this.state.popUpPosition.x}
            entries={this.state.popUpEntries}
          />
        )}
        <div style={explorerStyles.menuBar}>
          <div style={explorerStyles.title}>
            {currentDirectory ? currentDirectory.getName() : ""}
          </div>
          <div
            style={explorerStyles.menuButton}
            onClick={() => {
              if (currentDirectory.getParent())
                this.changeCurrentDirectory(currentDirectory.getParent());
            }}
            onMouseOver={this.highlight}
            onMouseOut={this.unhighlight}
          >
            <RollbackOutlined />
          </div>
        </div>
        <EntryList
          entries={entries}
          rowHeight={this.props.rowHeight}
          containerStyle={explorerStyles.frame}
          entryStyle={explorerStyles.entry}
        />
        <div style={explorerStyles.menuBar}>
          <input
            style={{
              ...explorerStyles.inputBox,
              width: this.props.width - 60,
            }}
            value={this.state.inputValue}
            onChange={this.changeInputValue}
            placeholder={"Enter Name"}
          />
          <div
            style={explorerStyles.menuButton}
            onClick={this.createFile}
            onMouseOver={this.highlight}
            onMouseOut={this.unhighlight}
          >
            <FileAddOutlined />
          </div>
          <div
            style={explorerStyles.menuButton}
            onClick={this.createDirectory}
            onMouseOver={this.highlight}
            onMouseOut={this.unhighlight}
          >
            <FolderAddOutlined />
          </div>
        </div>
      </div>
    );
  }
}

export default FileExplorer;
